module.exports = __webpack_public_path__ + "media/images/bnr-insta-feed-06490e8497a5e9d6a3fc7b8fb7116fc7.png";